import { take, fork, all } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './onlineSimulatedActions';

export const getEvaluationsOnline = apiTask(
  actions.GET_EVALUATIONS_ONLINE,
  api.post,
  '/evaluation-system-student/getEvaluationsOnline.php',
);

export function* watchGetEvaluationsOnline() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATIONS_ONLINE);
    yield fork(getEvaluationsOnline, payload);
  }
}

export const answerEvaluationOnline = apiTask(
  actions.ANSWER_EVALUATION_ONLINE,
  api.post,
  '/evaluation-system-student/answerEvaluationOnline.php',
);

export function* watchAnswerEvaluationOnline() {
  while (true) {
    const { payload } = yield take(actions.ANSWER_EVALUATION_ONLINE);
    yield fork(answerEvaluationOnline, payload);
  }
}

export const answerQuestion = apiTask(
  actions.ANSWER_QUESTION,
  api.post,
  '/evaluation-system-student/answerQuestion.php',
);

export function* watchAnswerQuestion() {
  while (true) {
    const { payload } = yield take(actions.ANSWER_QUESTION);
    yield fork(answerQuestion, payload);
  }
}

export const finishScheduledAssessment = apiTask(
  actions.FINISH_SCHEDULED_ASSESSMENT,
  api.post,
  '/evaluation-system-student/finishScheduledAssessment.php',
);

export function* watchFinishScheduledAssessment() {
  while (true) {
    const { payload } = yield take(actions.FINISH_SCHEDULED_ASSESSMENT);
    yield fork(finishScheduledAssessment, payload);
  }
}

export const viewEvaluationOnline = apiTask(
  actions.VIEW_EVALUATION_ONLINE,
  api.post,
  '/evaluation-system/viewEvaluationOnline.php',
);

export function* watchViewEvaluationOnline() {
  while (true) {
    const { payload } = yield take(actions.VIEW_EVALUATION_ONLINE);
    yield fork(viewEvaluationOnline, payload);
  }
}

export const getEvaluationEssayDetails = apiTask(
  actions.GET_EVALUATION_ESSAY_DETAILS,
  api.post,
  '/evaluation-system-student/getEvaluationEssayDetails.php',
);

export function* watchGetEvaluationEssayDetails() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATION_ESSAY_DETAILS);
    yield fork(getEvaluationEssayDetails, payload);
  }
}

export const saveEvaluationEssayText = apiTask(
  actions.SAVE_EVALUATION_ESSAY_TEXT,
  api.post,
  '/evaluation-system-student/saveEvaluationEssayText.php',
);

export function* watchSaveEvaluationEssayText() {
  while (true) {
    const { payload } = yield take(actions.SAVE_EVALUATION_ESSAY_TEXT);
    yield fork(saveEvaluationEssayText, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([
    fork(watchGetEvaluationsOnline),
    fork(watchAnswerEvaluationOnline),
    fork(watchAnswerQuestion),
    fork(watchFinishScheduledAssessment),
    fork(watchViewEvaluationOnline),
    fork(watchGetEvaluationEssayDetails),
    fork(watchSaveEvaluationEssayText),
  ]);
}
